__turbopack_context__.v({
  "chevron": "channelChip-module-scss-module__lSlduq__chevron",
  "chip": "channelChip-module-scss-module__lSlduq__chip",
  "icon": "channelChip-module-scss-module__lSlduq__icon",
  "label": "channelChip-module-scss-module__lSlduq__label",
});
